// src/pages/admin/{Notice1FormForm.js
import React from "react";
import FormWrapper from "../../forms/shared/FormWrapper";
import Notice3Form from "../../forms/anounce/Notice-of-Dissolution-3th-Publication/NoticeofDissolution3thPublication";

function Notice3Page() {
  return (
    <FormWrapper
      title="เลิกบริษัทประกาศเลิกขั้นตอนที่3-อนุมัติงบการเงิน"
      FormComponent={Notice3Form}
      formKey="notice-dissolution-3th" // key ไว้แยกชื่อไฟล์รูป/เก็บ localStorage ถ้ามี
    />
  );
}

export default Notice3Page;
